import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import styles from './styles';
var useStyles = createUseStyles(styles);
var AccessibleHiddenText = function AccessibleHiddenText(props) {
  var classesProp = props.classes,
    className = props.className,
    text = props.text;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  if (!text) {
    return;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: cx(classes.container, className)
  }, text);
};
AccessibleHiddenText.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  text: PropTypes.string
};
AccessibleHiddenText.defaultProps = {
  className: null,
  classes: {},
  text: ''
};
export default withMemo()(AccessibleHiddenText);